import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** The ISO country code for the flag to display*/
  countryCode: PropTypes.oneOf(['AE', 'APO/FPO', 'AR', 'AS', 'AT', 'AU', 'AW', 'BA', 'BB', 'BD', 'BE', 'BG', 'BH', 'BM', 'BN', 'BO', 'BR', 'BS', 'BZ', 'CA', 'CC', 'CH', 'CL', 'CN', 'CO', 'CR', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'EC', 'EE', 'EG', 'ES', 'FI', 'FM', 'FR', 'GB', 'GD', 'GL', 'GR', 'GT', 'GU', 'HK', 'HN', 'HR', 'HU', 'ID', 'IE', 'IL', 'IN', 'IS', 'IT', 'JM', 'JP', 'KN', 'KR', 'KW', 'KY', 'LB', 'LK', 'LT', 'LU', 'LV', 'MC', 'MH', 'MO', 'MP', 'MQ', 'MT', 'MU', 'MX', 'MY', 'NI', 'NL', 'NO', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PR', 'PT', 'PW', 'PY', 'QA', 'RO', 'RU', 'SA', 'SE', 'SG', 'SI', 'SK', 'SV', 'TH', 'TN', 'TR', 'TT', 'TW', 'UA', 'UM', 'US', 'UY', 'VE', 'VG', 'VI', 'VN', 'ZA']).isRequired,
  /** Optional country name to display next to the flag. If provided, flag icon is decorative */
  countryName: PropTypes.string,
  /** Optional size for the flag block. 'l' renders a large flag */
  size: PropTypes.oneOf(['l']),
  /** Optional theme for the flag block */
  theme: PropTypes.oneOf(['inverse'])
};
function FlagBlock(_ref) {
  var countryCode = _ref.countryCode,
    countryName = _ref.countryName,
    size = _ref.size,
    theme = _ref.theme;
  return /*#__PURE__*/React__default.createElement("span", {
    className: "flag-block",
    "data-testid": "flag-block",
    "data-size": size || null,
    "data-theme": theme || null
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-label": countryName ? '' : countryCode,
    className: "flag-block-icon",
    "data-country-code": countryCode,
    role: "img"
  }), countryName ? /*#__PURE__*/React__default.createElement("span", {
    className: "flag-block-text"
  }, countryName) : null);
}
FlagBlock.propTypes = propTypes;
FlagBlock.displayName = 'FlagBlock';

export { FlagBlock as default };
//# sourceMappingURL=FlagBlock.js.map
